var map = {
	"./audio-file.svg": "bfe5",
	"./audio-link.svg": "2fc3",
	"./doc-file.svg": "51fb",
	"./document-icon.png": "132b",
	"./link-icon.png": "8452",
	"./link.svg": "af41",
	"./mic-icon.png": "2d6a",
	"./player-icon.png": "755b",
	"./video-file.svg": "5cfa",
	"./video-link.svg": "427a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a623";